module.exports = __webpack_public_path__ + "img/menu_bg.4644ac80.png";